import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
} from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import type { ICoverTemplate } from "./types/icover-template";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface Props {
  template: ICoverTemplate;
  onEdit: (t: ICoverTemplate) => void;
  onDelete: (id: string) => void;
}

const CoverTemplateCard: React.FC<Props> = ({ template, onEdit, onDelete }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          borderRadius: 1,
          boxShadow: 0,
          "&:hover": { boxShadow: 3 },
        }}
      >
        <CardMedia
          component="img"
          height="180"
          image={template.foreground_image || ""}
          alt={template.name}
          sx={{ objectFit: "cover" }}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">{template.name}</Typography>
            <Chip
              label={template.category.replace("_", " ")}
              color="primary"
              size="small"
            />
          </Box>

          <Typography variant="body2" color="text.secondary" mt={1}>
            Created:{" "}
            {template.created_at
              ? new Date(template.created_at).toLocaleDateString()
              : "N/A"}
          </Typography>

          <Box display="flex" gap={1} mt={2}>
            <Button
              startIcon={<EditIcon />}
              onClick={() => onEdit(template)}
              size="small"
              sx={{
                flex: 1,
                backgroundColor: reduxTheme.primary_colors[800],
                color: reduxTheme.primary_colors[100],
              }}
            >
              Edit
            </Button>
            <Button
              startIcon={<DeleteIcon />}
              onClick={() => onDelete(template.id)}
              size="small"
              sx={{
                flex: 1,
                backgroundColor: reduxTheme.primary_colors[400],
                color: reduxTheme.primary_colors[900],
              }}
            >
              Delete
            </Button>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default CoverTemplateCard;
